// libs
import React, { memo, useState } from "react";

// components
import Input from "shared/components/AuthModal/components/Input";

// constants
import { TEXTS } from "./constants";

// styled components
import { Container, Button } from "./styles";

// defs
interface IPasswordProps {
    onChange: React.FormEventHandler<HTMLInputElement>;
    dataCy?: string;
    hasError?: boolean;
    className?: string;
}

function Password({ onChange, dataCy, hasError, className }: IPasswordProps) {
    const [canShowPassword, updateShowPassword] = useState(false);
    const inputType = canShowPassword ? "text" : "password";
    const btnText = canShowPassword ? TEXTS.HIDE : TEXTS.SHOW;

    const onBtnClick = () => updateShowPassword(!canShowPassword);

    return (
        <Container className={className}>
            <Input
                type={inputType}
                onChange={onChange}
                autoComplete="current-password"
                data-cy={dataCy}
                hasError={hasError}
                data-test="password-input"
                className="input"
            />
            <Button type="button" data-test="password-show" onClick={onBtnClick}>
                {btnText}
            </Button>
        </Container>
    );
}

export default memo(Password);
